<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdLearningResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      with-custom-row-actions-first-column
                                      custom-row-actions-text-first-column="预览"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="edit" custom-icon="fa fa-file-upload fa-lg fa-arrow-down"
                                               custom-label="上传文件"
                                               v-menu-permission="'edit'"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="uploadFileDialog()"
                                    >
                                    </em-button>
                                </template>
                                <template #customRowActionsFirstColumn="{row}">
                                    <b-button-group>
                                        <em-button
                                            type="previewPdfFile"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="previewPdfFile(row)"
                                        ></em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog
            title="上传文件"
            :center="true"
            width="30%"
            :visible.sync="uploadDialogVisible">
            <el-form :model="form" size="small" label-width="80px">
                <el-form-item label="部门">
                    <el-select v-model="form.locationId" style="width: 80%;">
                        <el-option
                            v-for="item in locationList"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model="form.name" style="width: 80%;"/>
                </el-form-item>
                <el-form-item label="文件编号">
                    <el-input v-model="form.version" style="width: 80%;"/>
                </el-form-item>
                <!--   上传文件   -->
                <el-form-item label="上传">
                    <el-upload
                        ref="upload"
                        :limit="1"
                        :on-change="handleChange"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :auto-upload="false"
                        :headers="headers"
                        :action="entityBaseUrl+'create?locationId='+form.locationId+'&name='+form.name+'&version='+form.version"
                        style="width: 80%;">
                        <div slot="trigger" class="sith-upload"><i class="el-icon-upload"/> 添加文件</div>
                        <div slot="tip" class="el-upload__tip">可上传文件不超过100M</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="uploadDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="uploadFile">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
// Author Eric
// Date 2021-04-28 16:18:42

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emApiMixin from "@/mixin/em/common/api";

export default {
    name: "sithMesPrdLearningListView",
    mixins: [emCommonListMixin, emCommonGotoMixin, emApiMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            uploadDialogVisible: false,
            form: {
                name: '',
                version: '',
                locationId: ''
            },
            locationList: {
                text: '',
                value: ''
            }
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
        },
        headers() {
            let headers = {};
            headers['Authorization'] = localStorage['em_sso_token'];
            return headers;
        },
    },
    methods: {
        previewPdfFile(row) {
            if (row.suffix === "pdf") {
                this.$router.push({
                    path: `/pdf/previewer`,
                    query: {src: `/sith-mes/sithMesPrdLearning/file?id=${row.id}`}
                });
            }
        },
        handleChange(file) {
            var fileName = file.name;
            this.form.name = fileName.substr(0, fileName.lastIndexOf("."));
            if (file.size > 100 * 1024 * 1024) {
                this.$message.warning({
                    duration: 5000,
                    message: "文件超过100M，请压缩后再上传"
                });
            }
        },
        handleSuccess() {
            this.$refs.upload.clearFiles();
            this.$nextTick(() => this.$store.commit("sithMesPrdLearning/setNeedToRefresh", true));
        },
        handleError(error) {
            this.$store.dispatch("base/showAlert", {
                modalTitle: '附件上传失败',
                modalHeader: '附件上传失败',
                modalContent: error.message,
            }, {root: true});
            this.$nextTick(() => this.$store.commit("sithMesPrdLearning/setNeedToRefresh", false));
        },
        uploadFileDialog() {
            this.form.name = null;
            this.form.locationId = null;
            this.form.version = null;
            this.locationList = this.$store.state.sithMesMstLocation.selectItems.get('locationIdFilter');
            this.uploadDialogVisible = true;

        },
        uploadFile() {
            if (!this.form.locationId) {
                this.$message.error("请选择部门");
                return;
            }
            if (!this.form.name) {
                this.$message.error("请输入文件标题");
                return;
            }
            this.$refs.upload.submit();
            this.uploadDialogVisible = false;
        }
    }
};
</script>
